import { type FC } from 'react';
import Link from 'next/link';

import { cn } from '@/lib/utils';

import { Caption } from '@/components/atoms/Typography/Caption';

interface GooglePoliciesInfoProps {
    className?: string;
}

const GooglePoliciesInfo: FC<GooglePoliciesInfoProps> = ({ className }) => (
    <Caption
        size="3xs"
        className={cn('text-center text-typo-secondary', className)}
    >
        Ta strona jest chroniona przez reCAPTCHA i Google -
        <Link
            className="ml-1"
            target="_blank"
            href="https://policies.google.com/privacy"
        >
            Polityka prywatności
        </Link>
        . Sprawdź
        
        <Link
            className="ml-1"
            target="_blank"
            href="https://policies.google.com/terms"
        >
            Warunki korzystania z usługi
        </Link>
        .
    </Caption>
);

export default GooglePoliciesInfo;
